var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1934,
    cy: 16.6094,
    r: 15.7715,
    fill: "#C3A6F1",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.91602,
    y: 9.62354,
    width: 5.41222,
    height: 5.41248,
    rx: 0.617764,
    stroke: "#914DE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.91602,
    y: 18.1826,
    width: 5.41222,
    height: 5.41248,
    rx: 0.617764,
    stroke: "#914DE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0566,
    y: 9.62354,
    width: 5.41222,
    height: 5.41248,
    rx: 0.617764,
    stroke: "#914DE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0566,
    y: 18.1826,
    width: 5.41222,
    height: 5.41248,
    rx: 0.617764,
    stroke: "#914DE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar4);
export default __webpack_public_path__ + "static/media/sideBar4.4181e8447a4b757cdd29e678026f16b3.svg";
export { ForwardRef as ReactComponent };